import { UiService } from '@adaptiva/core/ui';
import { CustomProperties, MetadataSerialization } from '@adaptiva/metadata/common';
import { KeyValueBuilderComponent } from '@adaptiva/widgets/key-value-builder';
import { ChangeDetectionStrategy, Component, ViewChild } from '@angular/core';
import { BaseAuthoringPropertiesComponent } from '../base-authoring-component';

@Component({
	standalone: false,
	selector: 'ada-custom-properties',
	templateUrl: './custom-properties.component.html',
	changeDetection: ChangeDetectionStrategy.OnPush
})
export class CustomPropertiesComponent extends BaseAuthoringPropertiesComponent<CustomProperties> {
	@ViewChild('CustomPropertiesInput')
	public customPropertiesInput: KeyValueBuilderComponent;
	
	public propertyConstructor: MetadataSerialization.Deserializable<CustomProperties> = CustomProperties;

	constructor (_ui: UiService) {
		super(_ui);
	}

	commitModelToView(): void {
		if (this.customPropertiesInput && this.currentPropertyObject) {
			this.customPropertiesInput.setEntries(this.currentPropertyObject);
		}
	}

	public override setCurrentPropertyObject(_object: CustomProperties): void {
		super.setCurrentPropertyObject(new CustomProperties(_object));
	}
}
